import { useRef, useState } from 'react'
import useIsInViewport from 'use-is-in-viewport'
import useDebounce from '../components/BatchProposal/hook/useDebounce'

const useVisibleViewport = (options = {}) => {
  const {
    onEnterViewport,
    threshold = 50,
    debounceTime = 300
  } = options
  const scrollHeight = useRef(0)
  const [isInViewport, viewportRef] = useIsInViewport({ threshold })
  const [visible, setVisible] = useState(isInViewport)

  useDebounce(
    () => {
      const currentScrollHeight = window.scrollY
      if (scrollHeight.current === currentScrollHeight) {
        return
      }
      scrollHeight.current = currentScrollHeight
      setVisible(isInViewport)
      onEnterViewport && onEnterViewport()
    },
    debounceTime,
    [scrollHeight, isInViewport]
  )

  return {
    viewportRef,
    visible
  }
}

export default useVisibleViewport
